<template>
  <div id="contactform">
    <b-row>
          <b-col cols="1">  </b-col>

      <b-col cols="8">
          <b-navbar>
 <b-navbar-toggle target="navbar-toggle-collapse">
      <template #default="{ expanded }">
        <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
        <b-icon v-else icon="chevron-bar-down"></b-icon>
      </template>
    </b-navbar-toggle>
    <b-navbar-brand href="http://www.nivas.info"><h1>Nivas Durairaj</h1></b-navbar-brand>

    
  </b-navbar>
    <hr>
    <h3>Send me a message</h3>
      <b-form @submit="onSubmit">

     <b-form-group
        id="input-group-1"
        label="Email address"
        label-for="input-1"
      >
        <b-form-input
          id="input-1"
          v-model="email"
          type="email"
          placeholder="Enter email"
          required
        ></b-form-input>
      </b-form-group>
<b-form-group
      id="fieldset-1"
      label="Your name"
      label-for="input-1"
      valid-feedback="Thank you!"
      :invalid-feedback="invalidFeedback"
      :state="state"
    >
      <b-form-input id="input-1" placeholder="Enter name"
 v-model="name" :state="state" trim></b-form-input>
    </b-form-group>
 
 <b-form-group
      id="fieldset-1"
      label="Message"
      label-for="input-1"
      valid-feedback="Thank you!"
      :invalid-feedback="invalidFeedback"
      :state="state"
    >
 <b-form-textarea
      id="textarea"
      v-model="text"
      placeholder="Enter message"
      rows="3"
      max-rows="10"
    ></b-form-textarea>
    </b-form-group>
      <b-button type="submit" variant="primary">Submit</b-button>

</b-form>
 </b-col>
       <b-col>
          <img src="@/assets/callme.png" class="hello" height="300" width="100%" fluid alt="Nivas Emoji saying hello"/>

         </b-col>

  </b-row>
<br/>
<br/>

<br/>
<br/>

  <myfooter/>
  </div>
</template>


<script>

import myfooter from '../components/myfooter.vue'



export default {
  name: 'ContactForm',
  components: {
    myfooter
  },
  data: function () {
    return { date: 
    
     new Date().toISOString().substr(0, 10)  }
      // 05/09/2019
  }

}
</script>

<style scoped> 

.hello {
  margin-top: 150px; 
  max-width:100%;
height:auto; 
}


.navbar-nav {
            margin-left: auto;
        }
</style>